import { render, staticRenderFns } from "./DocumentUploadModal.vue?vue&type=template&id=73cab303&"
import script from "./DocumentUploadModal.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73cab303')) {
      api.createRecord('73cab303', component.options)
    } else {
      api.reload('73cab303', component.options)
    }
    module.hot.accept("./DocumentUploadModal.vue?vue&type=template&id=73cab303&", function () {
      api.rerender('73cab303', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/DocumentUploadModal.vue"
export default component.exports